// Centralized, editable business configuration.
// Anything marked VERIFY must be confirmed with the client before launch.
export const business = {
  name: "Lavniya Beauty Salon",
  tagline: "Beauty • Hair • Grooming",
  phone: "+919783185829",
  phoneDisplay: "+91 97831 85829",
  whatsapp: "919783185829",
  address: "Paldi Meena, Jaipur, Rajasthan",
  hours: "8:00 AM – 9:00 PM, Daily", // VERIFY BEFORE LAUNCH
  rating: "5.0", // VERIFY BEFORE LAUNCH
  reviewCount: "760", // VERIFY BEFORE LAUNCH
  googleMapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Lavniya+Beauty+Salon+Paldi+Meena+Jaipur",
  googleReviewsUrl:
    "https://www.google.com/maps/search/?api=1&query=Lavniya+Beauty+Salon+Paldi+Meena+Jaipur+reviews",
  verifyLabel: "Verify before launch",
};

export const telLink = `tel:${business.phone}`;

export const waLink = (message) =>
  `https://wa.me/${business.whatsapp}?text=${encodeURIComponent(
    message || `Hi ${business.name}! I'd like to enquire about your services.`
  )}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "gallery", label: "Gallery" },
  { id: "reviews", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export const services = [
  {
    title: "Hair & Styling",
    icon: "scissors",
    desc: "Haircuts, styling, hair colour, treatments, hair spa and keratin care.",
  },
  {
    title: "Skin & Facials",
    icon: "sparkles",
    desc: "Facials, cleanups and D-Tan to refresh and care for your skin.",
  },
  {
    title: "Waxing & Threading",
    icon: "feather",
    desc: "Gentle waxing and precise threading for a clean, polished look.",
  },
  {
    title: "Nails",
    icon: "hand",
    desc: "Manicure and pedicure for well-groomed hands and feet.",
  },
  {
    title: "Makeup",
    icon: "brush",
    desc: "Everyday, party, occasion and bridal makeup by careful hands.",
  },
  {
    title: "Men's Grooming",
    icon: "user",
    desc: "Haircuts, beard trimming, shaving and everyday grooming for men.",
  },
];

export const featured = [
  {
    title: "Hair Spa",
    img: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=900&q=80",
    alt: "Relaxing hair spa treatment with towels and candles",
  },
  {
    title: "Keratin",
    img: "https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&w=900&q=80",
    alt: "Smooth, styled hair after a keratin treatment",
  },
  {
    title: "Facial",
    img: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=900&q=80",
    alt: "Facial treatment being applied in a calm salon setting",
  },
  {
    title: "Occasion / Bridal Makeup",
    img: "https://images.pexels.com/photos/11742214/pexels-photo-11742214.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Bride in traditional attire with elegant makeup",
  },
  {
    title: "Hair Styling",
    img: "https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=900&q=80",
    alt: "Stylist working on a client's hair in the salon",
  },
  {
    title: "Waxing",
    img: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=900&q=80",
    alt: "Calm spa room prepared for a waxing session",
  },
];

export const galleryItems = [
  { src: "https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=800&q=80", category: "Hair", alt: "Hair stylist at work in the salon" },
  { src: "https://images.pexels.com/photos/11742214/pexels-photo-11742214.jpeg?auto=compress&cs=tinysrgb&w=800", category: "Makeup", alt: "Bridal makeup with traditional jewellery" },
  { src: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=800&q=80", category: "Beauty", alt: "Facial treatment in progress" },
  { src: "https://images.unsplash.com/photo-1604654894610-df63bc536371?auto=format&fit=crop&w=800&q=80", category: "Nails", alt: "Manicured nails with neutral polish" },
  { src: "https://images.pexels.com/photos/13068357/pexels-photo-13068357.jpeg?auto=compress&cs=tinysrgb&w=800", category: "Salon", alt: "Modern salon interior with mirrors" },
  { src: "https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&w=800&q=80", category: "Hair", alt: "Styled, glossy hair finish" },
  { src: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?auto=format&fit=crop&w=800&q=80", category: "Makeup", alt: "Makeup being applied with a brush" },
  { src: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=800&q=80", category: "Beauty", alt: "Spa setting with candles and towels" },
  { src: "https://images.unsplash.com/photo-1610992015732-2449b76344bc?auto=format&fit=crop&w=800&q=80", category: "Nails", alt: "Nail polish being applied" },
  { src: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?auto=format&fit=crop&w=800&q=80", category: "Salon", alt: "Salon chairs and styling stations" },
  { src: "https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=800&q=80", category: "Hair", alt: "Hairdresser finishing a haircut" },
  { src: "https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?auto=format&fit=crop&w=800&q=80", category: "Makeup", alt: "Set of makeup brushes close up" },
  { src: "https://images.pexels.com/photos/13068377/pexels-photo-13068377.jpeg?auto=compress&cs=tinysrgb&w=800", category: "Salon", alt: "Warm, modern beauty studio interior" },
];

export const heroImage = {
  src: "https://images.unsplash.com/photo-1756483560049-e7b2208f99a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBsdXh1cnklMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODUwNjYyODV8MA&ixlib=rb-4.1.0&q=85",
  alt: "Smiling Indian woman adorned in elegant jewellery",
};

export const aboutImages = [
  {
    src: "https://images.pexels.com/photos/13068377/pexels-photo-13068377.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Warm, modern beauty salon interior",
  },
  {
    src: "https://images.unsplash.com/photo-1570212773364-e30cd076539e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBsdXh1cnklMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODUwNjYyODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Woman in a traditional sari, styled for an occasion",
  },
];

export const faqs = [
  {
    q: "What services do you offer?",
    a: "Hair styling, haircuts, hair colour, hair treatments, hair spa, keratin, facials, cleanup, D-Tan, waxing, threading, manicure, pedicure, makeup, bridal and occasion makeup, beard trimming, shaving and men's grooming — all in one place.",
  },
  {
    q: "Do I need an appointment?",
    a: "Walk-ins are welcome when slots are free, but we recommend booking ahead on call or WhatsApp so you don't have to wait. (Editable — confirm policy before launch.)",
  },
  {
    q: "Do you offer bridal or occasion makeup?",
    a: "Yes, occasion and bridal makeup is available. Message us on WhatsApp with your date and requirements and we'll help you plan. (Editable — confirm details before launch.)",
  },
  {
    q: "How much do services cost?",
    a: "Prices depend on the service and your hair or skin needs. Call or WhatsApp us for a quick, honest quote — no obligation.",
  },
  {
    q: "Where are you located?",
    a: "We're in Paldi Meena, Jaipur, Rajasthan. Use the Get Directions button on this page to open our location in Google Maps.",
  },
  {
    q: "What are your opening hours?",
    a: `Currently listed as ${business.hours}. ${business.verifyLabel}.`,
  },
];
